<template>

    <div class="container mx-auto py-8">
        <h1 class="text-center capitalize">
            <span class="font-unifraktur text-5xl lg:text-6xl font-bold tracking-tight">The New York Times </span>
            <span class="text-2xl lg:text-4xl font-semibold">Critic's Picks</span>
        </h1>
    </div>

</template>

<script>
export default {

}
</script>

<style>

</style>